import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { OptionsColor } from "../../OptionsColor";
export var MoveTrailFill = /*#__PURE__*/function () {
  function MoveTrailFill() {
    _classCallCheck(this, MoveTrailFill);
  }

  _createClass(MoveTrailFill, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.color !== undefined) {
        this.color = OptionsColor.create(this.color, data.color);
      }

      if (data.image !== undefined) {
        this.image = data.image;
      }
    }
  }]);

  return MoveTrailFill;
}();